
import React from 'react';

export const FinancialTermsHero: React.FC = () => {
  return (
    <section className="relative bg-gradient-to-br from-emerald-50 to-teal-100 py-20 overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/03f4a224fd67d3eb5516a39cf394b5c7.jpg')`
        }}
      />
      
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-black/5 to-black/10"></div>
      
      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            Key Financial Terms for 
            <span className="text-teal-600 block mt-2">Apartment Building Sellers</span>
          </h1>
          
          <p className="text-xl md:text-2xl text-gray-700 mb-8 max-w-4xl mx-auto leading-relaxed">
            Master essential financial terminology, valuation methods, and cost calculations to maximize your net earnings from apartment building sales
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <div className="flex items-center text-gray-600">
              <i className="ri-time-line text-teal-600 mr-2"></i>
              <span className="text-lg">15 min read</span>
            </div>
            <div className="flex items-center text-gray-600">
              <i className="ri-bookmark-line text-teal-600 mr-2"></i>
              <span className="text-lg">Essential Guide</span>
            </div>
            <div className="flex items-center text-gray-600">
              <i className="ri-calculator-line text-teal-600 mr-2"></i>
              <span className="text-lg">20+ Financial Terms</span>
            </div>
          </div>

          {/* Key Topics Preview */}
          <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-8 shadow-xl border border-white/20 max-w-5xl mx-auto">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">What You'll Learn</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 text-left">
              <div className="flex items-start">
                <div className="w-2 h-2 bg-teal-600 rounded-full mt-3 mr-3 flex-shrink-0"></div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Property Valuation</h3>
                  <p className="text-gray-600 text-sm">NOI, Cap Rates, and Appraisal Methods</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-2 h-2 bg-teal-600 rounded-full mt-3 mr-3 flex-shrink-0"></div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Transaction Costs</h3>
                  <p className="text-gray-600 text-sm">Closing Costs and Commissions</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-2 h-2 bg-teal-600 rounded-full mt-3 mr-3 flex-shrink-0"></div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Tax Strategies</h3>
                  <p className="text-gray-600 text-sm">1031 Exchanges and Capital Gains</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-2 h-2 bg-teal-600 rounded-full mt-3 mr-3 flex-shrink-0"></div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Net Earnings</h3>
                  <p className="text-gray-600 text-sm">Calculate Your True Profit</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-2 h-2 bg-teal-600 rounded-full mt-3 mr-3 flex-shrink-0"></div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Legal Documents</h3>
                  <p className="text-gray-600 text-sm">Deeds, Escrow, and Title Insurance</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-2 h-2 bg-teal-600 rounded-full mt-3 mr-3 flex-shrink-0"></div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Market Analysis</h3>
                  <p className="text-gray-600 text-sm">CMA and Property Appreciation</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
